import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";

export function useRentalDispatchData() {
  const [dispatches, setDispatches] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [assets, setAssets] = useState([]);
  const [items, setItems] = useState([]);
  const load = useCallback(() => api.get("/fractank/dispatches").then((r) => setDispatches(r.data)).catch((e) => toast.error(errMsg(e))), []);
  useEffect(() => {
    load();
    api.get("/customers").then((r) => setCustomers(r.data)).catch(() => {});
    api.get("/assets").then((r) => setAssets(r.data)).catch(() => {});
    api.get("/product-service-items").then((r) => setItems(r.data)).catch(() => {});
    const interval = setInterval(load, 10000);
    return () => clearInterval(interval);
  }, [load]);
  return { dispatches, customers, assets, items, load };
}
